import FunctionButton from "components/common/FuncButton";
import { useHttpUtil } from "context/HttpContext";
import { useProject } from "hooks/UseProject";
import { useEffect, useRef, useState } from "react";
import { useDetailContext } from "../DetailContext";
import { ActionName } from "../MockupEditor";
import CustomImage from "components/common/CustomImage";
import Tools from "libs/utils/Tools";


export default function MouseMode(props: { setProject: Function, modeType: number}){
    const detailContext = useDetailContext();
    const {setProject, modeType} = props ;

    const [gotoAdd] = useProject();
    const httpUtil = useHttpUtil();

    const [name, setName] = useState<string>('');

    useEffect(() => {
        setName(detailContext?.project?.name || '');
    }, [ detailContext?.project?.name ])

    const inputNameRef = useRef<HTMLInputElement>(null);

    const saveProjectName = async function(){
        if(detailContext?.project){
            setProject({...detailContext.project, name})
            await httpUtil.post('/biz/project/update/name', {
                projectId: detailContext.project.projectId,
                name 
            })
        }
    }

    const selectedMode = (type: number) => {
        detailContext?.triggerEditorAction({ name: ActionName.CHANGE_MOUSE_MODE, params : `${type}`})
    }

    return (
        <div className="flex items-center gap-[13px]">
            <CustomImage src="/logo-short.png" className="w-[30px] h-[30px] cursor-pointer opacity-[0.8]"
                onClick={() => {location.href = Tools.disponseUrl('/')}}/>
            <div className="relative pl-[10px] group">
                <CustomImage src="/icon/icon-editor-more.png" className="w-[25px] cursor-pointer"/>
                <div className="absolute z-[10008] top-[25px] left-[5px] flex flex-col w-[150px] bg-[#FFFFFF] rounded-[10px] shadow-xl text-center group-hover:flex hidden">
                    <span className="py-[8px] cursor-pointer hover:bg-[#D9F2FF] rounded-t-[10px]"
                        onClick={() => inputNameRef.current?.select()}>Rename title</span>
                    <span className="py-[8px] cursor-pointer hover:bg-[#D9F2FF]"
                        onClick={() => gotoAdd()}>New project</span>
                    <span className="py-[8px] cursor-pointer hover:bg-[#D9F2FF]"
                        onClick={() => detailContext?.project && gotoAdd(detailContext.project.projectId)}>Duplicate project</span>
                    <span className="py-[8px] cursor-pointer hover:bg-[#D9F2FF] rounded-b-[10px]" 
                        onClick={() => location.href = Tools.disponseUrl('/')}>My project</span>
                </div>
            </div>
            <div className="">
                <input type="text" value={name} className="py-[7px] px-[10px] border focus:border-[#14A5FA] w-[140px] outline-none rounded-[6px] focus:select-all"
                    ref={inputNameRef}
                    onKeyDown={(e) => e.stopPropagation()}
                    onKeyUp={(e) => e.stopPropagation()}
                    onChange={(e) => { setName(e.target.value); e.stopPropagation(); }} 
                    onBlur={(e) => saveProjectName()}/>
            </div>
            <div className="xl:flex gap-[10px] hidden">
                <FunctionButton isActive={modeType == 0} title="Move" iconPath="/icon/icon-editor-selector.png" onClick={() => selectedMode(0)} 
                    bubble={{ title: 'Move'}} className="hover:bg-[#D9F2FF]"/>
                <FunctionButton isActive={modeType == 1} title="Hand" iconPath="/icon/icon-editor-hand.png" onClick={() => selectedMode(1)} 
                    bubble={{ title: 'Hand'}} className="hover:bg-[#D9F2FF]"/>
                {/* <FunctionButton isActive={modeType == 2} iconPath="/icon/icon-editor-frame.png" onClick={() => selectedMode(2)} 
                    bubble={{ title: 'Frame', desc: 'Multiple images can be put together into a single whole.'}}/> */}
            </div>
        </div>
    )
}

